































import { getSidebarData } from '@/api/static-content';
import Vue from 'vue';

export default Vue.extend({
  name: 'Sidebar',
  props: {
    pageName: {
      type: String,
      default: 'Sidebar'
    },
    isLoginPage: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      sidebarContent: {} as any
    };
  },
  mounted () {
    getSidebarData(this.pageName).then((data: any) => {
      this.sidebarContent = data;
    });
  }
});
